export function returnLabelBySlug(slug: string) {
	switch (slug) {
		case 'showcase_search_accessories':
			return 'Pesquisa acessórios de vitrine';

		case 'showcase_similars':
			return 'Vitrine de similares';

		case 'showcase_suggestions':
			return 'Vitrine de sugestões';

		case 'showcase_recomendations':
			return 'Mostragem de recomendação';

		case 'search_by_text':
			return 'Busca de texto';

		case 'search_by_image':
			return 'Busca por Imagem';

		case 'search_autocomplete':
			return 'Autocomplete de busca';

		case 'search_filters':
			return 'Vitrine também viu';

		case 'showcase_saw_also_saw':
			return 'Busca por filtros';

		case 'showcase_saw_also_bought':
			return 'Vitrine também comprado';

		case 'showcase_bought_also_bought':
			return 'Vitrine também comprou';

		case 'showcase_search_show_together':
			return 'Vitrine pesquisa mostrar juntos';

		default:
			return slug;
	}
}
